<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
     <span class="back" @click="$router.replace({path:'/userCenter/realName/personalInfo'})"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
      <div class="wrap" style="background:#fff">
        <div class="content">
          <h5 class="page-title">
            <span class="blue title-line"></span> 法人认证类型选择
          </h5>
          <div class="main-box">
           
            <ul class="choose">
              <li :class="activeIndex==3?'active':''" @click="chooseattestation(3)">
                <img class="jian" src="@/assets/images/jian.png" alt="" />
                <div class="introduce">
                  <h4><b>手机号认证</b>（即时完成认证）</h4>
                  <p>1.请确保手机号为本人在运营商处实名购买；</p>
                  <p>2.请确保手机号可以接收短信验证码。</p>
                </div>
                <div class="icon">
                  <img src="../../../assets/images/phone.png" alt="" />
                </div>
              </li>
            
              <li :class="activeIndex==2?'active':''" @click="chooseattestation(2)">
                <img class="jian" src="@/assets/images/jian.png" alt="" />
                <div class="introduce">
                  <h4><b>人脸识别</b>（即时完成认证）</h4>
                  <p>1.请确保手机内安装微信客户端；</p>
                  <p>2.请确保开通微信账号。</p>
                </div>
                <div class="icon">
                  <img src="../../../assets/images/face.png" alt="" />
                </div>
              </li>
                <li :class="activeIndex==1?'active':''" @click="chooseattestation(1)">
                <div class="introduce">
                  <h4><b>银行卡认证</b>（即时完成认证）</h4>
                  <p>1.请提前准备好您的银行卡资料；</p>
                  <p>2.确保办理该银行卡所预留的手机号，可以接收短信验证码。</p>
                   <p class="warning">
              <i class="el-icon-warning"></i>
              &nbsp;&nbsp;&nbsp;&nbsp;个人银行卡信息仅用于进行实名认证，不会绑定您的银行卡产生任何隐形消费，也不会泄露您的银行卡信息。
            </p>
                </div>
                
                <div class="icon">
                  <img src="../../../assets/images/bank.png" alt="" />
                </div>
                
              </li>
              
            </ul>
            <div class="footer">
                <p class="agreement">
                    <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                    <!-- <a v-if="activeIndex==2" href="https://miniprogram-kyc.tencentcloudapi.com/s/h5/protocolTencent.html" target="_blank">《人脸核身个人信息处理授权协议》</a> -->
                    <a :href="realNameAgreement" target="_blank" @click="lookDoc">《实名认证服务协议》</a>
                    <a :href="privacyAgreement" target="_blank">《隐私保护协议》</a>
                </p>
                <div class="btns">
                    <span :class="checked?'isClick':''" @click="goattestation">开始认证</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
import {identificationProtocol} from '@http/user_center/realName'

export default {
  data() {
    return {
      checked:false,
      activeIndex:'',
      realNameAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/realNameProtocol',
      privacyAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/privacy'
    };
  },

  components: {},

  computed: {},

  watch: {
      checked(newVal) {
          if(newVal){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35020,
                },
            });
          }else{
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35021,
                },
            });
          }
      },
  },

  created() {},

  mounted() {},

  methods: {
    lookDoc(){
        this.$TsaWebTrace.post({
            data: {
                "eventId": 35002,
            },
        });
    },
    chooseattestation(n){
        this.activeIndex=n;
    },
    goattestation(n) {
      if(!this.activeIndex){
          this.$msg("请先选择认证类型");
          return false;
      }
      if(!this.checked && this.activeIndex!==2){
          this.$msg("请先阅读并勾选协议");
          return false;
      }
      this.$TsaWebTrace.post({
          data: {
              "eventId": 35024,
          },
      });
      identificationProtocol().then(()=>{
        switch (this.activeIndex) {
          case 1:
            this.$router.push({
              path: "/userCenter/realName/legalBank",
            });
            break;
          case 2:
            this.$router.push({
              path: "/userCenter/realName/legalFace",
            });
            break;
          case 3:
            this.$router.push({
              path: "/userCenter/realName/legalPhone",
            });
            break;
        }
      }).catch((err) => {
        this.$msg("协议签署服务失败");
      });
    },
  },
};
</script>
<style src="../../../assets/css/content.css" scoped></style>
<style scoped lang="less">
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.warning{
  font-size: 12px;
}
.main-box {
  width: 940px;
  margin: 0 auto;
  .footer{
    margin:10px auto;
    .agreement{
        a{
            font-size: 14px;
            color: #1890ff;
        }
    }
    .btns{
        margin-top: 18px;
        text-align: center;
        span{
            cursor: pointer;
            display: inline-block;
            width: 123px;
            height: 36px;
            background:#188fff76;
            border-radius: 8px;
            color: #fff;
            line-height: 36px;
            text-align: center;
        }
        .isClick{
            background:#3758FF;
        }
    }
  }
}
.choose {
  margin-top: 30px;
}
.choose li {
  position: relative;
  width: 100%;
  border: 1px solid #eeeeee;
  box-shadow: 0px 3px 8px 0px rgba(85, 85, 85, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 30px;
  cursor: pointer;
  margin-bottom: 32px;
  font-size: 14px;
}
.choose .active{
  background: #f9fbff;
  border-color: #3f7df7;
}
.choose li:hover {
  background: #f9fbff;
  border-color: #3f7df7;
}
.introduce {
  flex: 1;
}
.introduce h4 {
  color: #333;
  margin-bottom: 18px;
}
.introduce h4 b {
  color: #333;
  font-size: 18px;
  font-weight: bold;
}
.introduce p {
  color: #666;
  line-height: 22px;
}
.jian {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
